module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "topicInfos",
    staticClass: "topicInfo",
    attrs: {
      "id": "topicInfo"
    }
  }, [_c('topBanner', {
    attrs: {
      "appName": _vm.appName,
      "topicInfo": _vm.topicInfo
    },
    on: {
      "headToApp": _vm.headToApp
    }
  }), _vm._v(" "), (_vm.topicDetailType === 1) ? _c('div', [_c('div', {
    staticClass: "topicInfo_back",
    style: (_vm.styleComputed),
    attrs: {
      "id": "topicInfo_back"
    }
  }, [_c('div', {
    staticClass: "topicInfo_head"
  }, [_c('div', {
    staticClass: "topicInfo_text"
  }, [_c('div', {
    staticClass: "topicInfo_title",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.title))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.description))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "topicInfo_button",
    class: {
      'cxjrbClass': _vm.showSubmit == 1
    },
    attrs: {
      "id": "topicInfo_button"
    }
  }, [(_vm.attention) ? _c('div', {
    staticClass: "topicInfo_btn themeBgColor openappAndroidwx",
    on: {
      "click": _vm.alertLogin
    }
  }, [_vm._v(_vm._s(_vm.isAppName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.attention === false) ? _c('div', {
    staticClass: "topicInfo_btn openappAndroidwx",
    on: {
      "click": _vm.alertLogin
    }
  }, [_vm._v("未关注")]) : _vm._e()])])]), _vm._v(" "), (_vm.alertShow) ? _c('div', {
    staticClass: "alert-modal"
  }, [_c('div', {
    staticClass: "alert-hd"
  }, [_c('div', [_vm._v("请登录客户端！")]), _vm._v(" "), _c('div', {
    staticClass: "alert-cancle",
    on: {
      "click": _vm.alertCancle
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "alert-sure openappAndroidwx",
    on: {
      "click": _vm.alertSure
    }
  }, [_vm._v("确定")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.topicDetailType === 2) ? _c('div', {
    staticClass: "topicDetailType2"
  }, [(this.bg) ? _c('div', {
    staticClass: "topicDetailType2-img"
  }, [_c('img', {
    attrs: {
      "src": ("" + (this.bg.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com'))),
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (1) ? _c('div', [_c('swiperAd', {
    attrs: {
      "sid": _vm.sid,
      "topicID": _vm.topicID,
      "uid": _vm.uid
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.topicInfo.isShowAllTopics == 1) ? _c('div', {
    staticClass: "previous-topics-main"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.topicDetailType === 1) ? _c('div', {
    staticClass: "topicInfo_foot"
  }, [_c('div', {
    staticClass: "interest"
  }, [(_vm.topicInfo.interestCount > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("parseCount")(_vm.topicInfo.interestCount)) + "人关注")]) : _vm._e(), _vm._v(" "), (_vm.topicInfo.topicCount > 0) ? _c('span', {
    staticClass: "t-line"
  }) : _vm._e(), _vm._v(" "), (_vm.topicInfo.topicCount > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("parseCount")(_vm.topicInfo.topicCount)) + "参与 ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "endTime"
  }, [_vm._v(_vm._s(_vm.timeShow))])]) : _vm._e(), _vm._v(" "), (_vm.topicDetailType === 2) ? _c('div', {
    staticClass: "topicDetailType2-head"
  }, [_c('div', {
    staticClass: "topicDetailType2-title",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.title))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "topicDetailType2-status"
  }, [(_vm.topicInfo.interestCount > 0) ? _c('span', {
    staticStyle: {
      "margin-right": "0.3rem"
    }
  }, [_vm._v(_vm._s(_vm._f("parseCount")(_vm.topicInfo.interestCount)) + "人关注")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "endTime"
  }, [_vm._v(_vm._s(_vm.timeShow))])]), _vm._v(" "), (_vm.topicInfo.description) ? _c('div', {
    staticClass: "topicDetailType2-des",
    class: {
      topicDetailType2DesDown: _vm.showMoreDesClass
    }
  }, [_c('div', {
    staticClass: "des-content",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.description))
    }
  }), _vm._v(" "), (_vm.showMoreDes) ? _c('span', {
    staticClass: "downArea",
    on: {
      "click": function($event) {
        _vm.showMoreDesChange()
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "desBoxss",
    staticStyle: {
      "position": "absolute",
      "z-index": "-11",
      "visibility": "hidden"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.description))
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showSubmit) ? _c('div', {
    staticClass: "submit-topic",
    class: this.isWx && 'iswx',
    on: {
      "click": function($event) {
        _vm.submitHref()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAiCAMAAADiW5DOAAAAkFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+WABnwAAAAL3RSTlMA+8WArgXks1geGBDQyKGNFAz28OvClV86Jhzo4b65pmpIQCrbp6NTUALYfHdzM59y9XAAAAEjSURBVDjLjdHXkoJQEEXRbkBwSGZAzFkn7f//uwG1kCq4OOt5U4fqKzVBP5m5Y8aulfQDabPzlBf1do0iiygtZs7ZmbmUokzqegMFXae5POTpWkEHPakEM+A0l7r5GbCGVRKCu2/M75cQBs+h1f2DpqEFq8ecDdFI2owisO/DysKXdr6Llr+5gYuYXOFUpEokZhbqyxb6YtaHrTjoSMxGiiNHQukScpRx0XVxGAtspMuvpzLBk25bCfmUd2LwjcexqgP8iAE8DzBh2XvTyAC+3jXDKZqZm+qPpofmW1as51oRdTe3GOzOrcLHv5thEqeH8gw9Y7NbUNCJO9Hv9maQUONlr7d4NQpq5xc79tZObF99qVRNYbmXLjmwCaTTbTVNxewPF/YoLOzIc4wAAAAASUVORK5CYII=",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("我要参与")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previous-topics openappAndroidwx wx-launch-app-btn-parent"
  }, [_c('span', [_vm._v("往期话题")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02NzYuNTc5NTU2IDUxMS4yNjA0NDRsLTM5MC4yNTc3NzgtMzkwLjIyOTMzM2EyOC40NDQ0NDQgMjguNDQ0NDQ0IDAgMSAxIDQwLjI0ODg4OS00MC4yMjA0NDM5OUw3MzYuOTEwMjIxOTkgNDkxLjE1MDIyMmEyOC40NDQ0NDQgMjguNDQ0NDQ0IDAgMCAxIDFlLTggNDAuMjIwNDQ1TDMyNi41NzA2NjcgOTQxLjcxMDIyMjAxYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAwIDEtNDAuMjIwNDQ1LTQwLjIyMDQ0NDAxTDY3Ni41Nzk1NTYgNTExLjI2MDQ0NHoiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD48L3N2Zz4=",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "arrowTip"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71c5e231"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topic/head.vue
// module id = 325
// module chunks = 1